export const DUPLICATE_DIALOG_MODE = {
    /** Create / deals / opp / services — suggest only */
    SUGGEST: 'suggest',
    /** Edit customer — suggest with Review and Merge → resolve */
    EDIT: 'edit',
    /** Banner Review and Merge — review list (non-selectable) then resolve */
    MERGE_REVIEW: 'mergeReview',
    /** Merge with current — jump straight to resolve */
    MERGE_DIRECT: 'mergeDirect',
};

export const DUPLICATE_DIALOG_STEP = {
    SUGGEST: 'suggest',
    RESOLVE: 'resolve',
    CONFIRM: 'confirm',
};
